import { render, staticRenderFns } from "./AssignedTo.vue?vue&type=template&id=59401ece&scoped=true"
import script from "./AssignedTo.vue?vue&type=script&lang=js"
export * from "./AssignedTo.vue?vue&type=script&lang=js"
import style0 from "./AssignedTo.vue?vue&type=style&index=0&id=59401ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59401ece",
  null
  
)

export default component.exports